import React, {useState, useEffect} from 'react';
import { Steps } from '../lib/constants';
import withAppState from '../mobx/withAppState';
import locationIcon from '../assets/img/icons/locationPin.svg';
import chevronLeftPlum from '../assets/img/icons/chevronLeftPlum.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faTimes } from '@fortawesome/free-solid-svg-icons';
import dataLayer from '../lib/dataLayer';

const {dataLayerAttribute} = dataLayer; 
const {addToDataLayerList} = dataLayer;
const DigitalMenuHeader = props => {
  const { dietaryFilterCta, dietaryFilter, restaurant, appPlatform, popStep, activeStep, previousSteps,popUpDisplayHandler } = props;
  const arrowLeft = <FontAwesomeIcon icon={faChevronLeft} />;
  const [footerBannerLinks, setFooterBannerLinks] = useState([]);
  let title = null;
  let copy = null;
  let linkText = null;
  let selectRestaurantText = !restaurant ? 'Select restaurant to see prices' : 'Change restaurant';
  let linkHref = null;
  let headerMessage = null;
  let link = "https://www.pizzaexpress.com/-/media/Files/PDFs/Event Menus/Event_Menu_";
  let bookATableUrl = "https://www.milano.ie";
  let orderOnlineUrl = "https://order.milano.ie/";
  let allergenUrl = "https://www.milano.ie/allergens-and-nutritionals";
  let bookATableName = "Book a table";
  let orderOnlineName = "Order Online";
  let allergenName = "Allergen & Nutritional Information";
  let menuType = null;

  // useEffect(() => {

    // }, [])
    useEffect(() => {
        let isMounted = true;
        async function fetchAPI() {
            try {
                const response = await fetch(`api/Menu/FooterBannerLinks`);
                if (response.status === 200 && isMounted) {
                    const data = await response.json();
                    if (isMounted) {
                        setFooterBannerLinks(data?.banners);
                    }
                }
            } catch (error) {
                // Handle error if needed
            }
        }

        fetchAPI();
    }, []);  

  switch (props.activeStep) {
    case Steps.RESTAURANT_SEARCH:
      if (!props.isCheckInJourney) {
        title = 'Our Menu';
        linkText = 'Allergen & Nutritional Information';
        linkHref = 'https://www.pizzaexpress.com/allergens-and-nutritionals';
        copy = '';
      } else {
        title = 'Test &amp; Trace Check-in';
        copy = `Welcome to everyone's favourite pizzeria. As per government regulations, it is mandatory for all customers to complete test
        and trace information whilst dining in our pizzerias. Please continue to enter in your details.`;
      }
      break;
    default:
      title = 'Our Menu';
      linkText = 'Allergen & Nutritional Information';
      linkHref = 'https://www.milano.ie/allergens-and-nutritionals';
      headerMessage = restaurant?.headerMessage ?
        <>
            <p>
                <strong>An update to all our customers</strong>
            </p>
            <p>
                During big events, we offer a shorter menu which helps our kitchens keep up with orders and serve you quickly so you can get to your event on time.
                {" "}
                <a href={link + restaurant?.headerMessage} download style={{ textDecoration: "underline" }}>
                    <strong>Click here</strong>
                </a>{" "}
                to view.
            </p>
        </>
        : null;
  }

  var buttonDisabled =
      previousSteps.length === 0 ||
      activeStep === Steps.PAYMENT_CONFIRMATION ||
      activeStep === Steps.SPLIT_BILL_NAME;
    if (footerBannerLinks?.find(md => md.name === "Book a table")) {
        const bookATable = footerBannerLinks.filter(md => md.name === "Book a table")[0];
        bookATableUrl = bookATable?.url;
        bookATableName = bookATable?.name;
    }

    if (footerBannerLinks?.find(md => md.name === "Order Online")) {
        const orderOnline = footerBannerLinks.filter(md => md.name === "Order Online")[0];
        orderOnlineUrl = orderOnline?.url;
        orderOnlineName = orderOnline?.name;
    }

    if (footerBannerLinks?.find(md => md.name === "Allergen & Nutritional Information")) {
        const allergen = footerBannerLinks.filter(md => md.name === "Allergen & Nutritional Information")[0]
        allergenUrl = allergen?.url;
        allergenName = allergen?.name;
    }

    
    if (!!restaurant?.restaurantUrlName) {
        bookATableUrl = bookATableUrl + `${restaurant.restaurantUrlName}/book/book-a-table`;
        menuType = "local menu";
    }
    else {
        bookATableUrl = bookATableUrl + "/book/book-a-table-uk";
        menuType = "global menu";
    }

  const handleBookClick = (e) => {
    
    var dataLayerArray = [];

      if (menuType === "local menu") {
          dataLayerArray.push(
              { [dataLayerAttribute.EVENT]: "book_link_clicked_banner" },
              { [dataLayerAttribute.PAGE_TYPE]: "book_link_clicked_banner" },
              { [dataLayerAttribute.MENU_TYPE]: menuType },
              { [dataLayerAttribute.TIMESTAMP]: new Date().toDateString() + " " + new Date().toLocaleTimeString() },
              { [dataLayerAttribute.RESTAURANT_ID]: restaurant?.id ? restaurant.id : -1 }
          );
      }
      else {
          dataLayerArray.push(
              { [dataLayerAttribute.EVENT]: "book_link_clicked_banner" },
              { [dataLayerAttribute.PAGE_TYPE]: "book_link_clicked_banner" },
              { [dataLayerAttribute.MENU_TYPE]: menuType },
              { [dataLayerAttribute.TIMESTAMP]: new Date().toDateString() + " " + new Date().toLocaleTimeString() },
          );
      }

    addToDataLayerList(dataLayerArray);
  }  

  const handleOrderClick =(e) => {

    var dataLayerArray = [];

      if (menuType === "local menu") {
          dataLayerArray.push(
              { [dataLayerAttribute.EVENT]: "order_link_clicked_banner" },
              { [dataLayerAttribute.PAGE_TYPE]: "order_link_clicked_banner" },
              { [dataLayerAttribute.TIMESTAMP]: new Date().toDateString() + " " + new Date().toLocaleTimeString() },
              { [dataLayerAttribute.MENU_TYPE]: menuType },
              { [dataLayerAttribute.RESTAURANT_ID]: restaurant?.id ? restaurant.id : -1 }
          );
      }
      else {
          dataLayerArray.push(
              { [dataLayerAttribute.EVENT]: "order_link_clicked_banner" },
              { [dataLayerAttribute.PAGE_TYPE]: "order_link_clicked_banner" },
              { [dataLayerAttribute.TIMESTAMP]: new Date().toDateString() + " " + new Date().toLocaleTimeString() },
              { [dataLayerAttribute.MENU_TYPE]: menuType }
          );
      }

  addToDataLayerList(dataLayerArray);
  }

  return (
    <div className="digital-menu-header home-card-intro">
      <div className="home-card-intro-inner">
        <div className="home-card-title">
          <div className="home-card-title-inner">
            {!!title && <h1>{title.toUpperCase()}</h1>}
            {!!copy && <p>{copy}</p>}
            {!!restaurant && <p style={{ color: 'white' }}>{restaurant.name}</p>}
                <button class="restaurant-location" onClick={popUpDisplayHandler}>
                    <img class="icon" src={locationIcon} alt="location icon"/>
                    <span>{selectRestaurantText}</span>
                </button>
                <div className="purchase-container-cta">
                  <a href={bookATableUrl} onClick={handleBookClick} className="menu-cta primary-cta book-cta">{bookATableName}</a>
                  <a href={orderOnlineUrl} onClick={handleOrderClick} className="menu-cta primary-cta order-cta">{orderOnlineName}</a> 
                </div>
            {!!linkText && <p style={{ paddingTop: '8px' }} className='allegen-nutritional-info'><a target="_blank" href={allergenUrl} style={{ textDecoration: 'underline', color: 'white', fontSize: '1.1rem' }}>{allergenName}</a></p>}
            {!!headerMessage && <p style={{ backgroundColor: '#FBDE40', padding: '1rem' }} >{headerMessage}</p>}

          </div>
        </div>   
        
      </div>
    </div>
  );
};

export default withAppState(DigitalMenuHeader, {
  mobXProps: ({ 
    activeStep, 
    previousSteps,
    isCheckInJourney, 
    restaurant,
    appPlatform, 
  }) => ({
    activeStep,
    previousSteps,
    isCheckInJourney,
    restaurant,
    appPlatform,
  }),
  mobXActions: ({
    popStep,
  }) => ({
    popStep,
  })
});
